export default {
    iconDropdownContainer: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer"
    },

    iconLabel: {
        cursor: "pointer",
        width: "max-content",
        marginRight: "5px"
    },
    dropDownContainer: {
        display: 'flex', 
        alignItems: 'center'
    }
}